import React, { useCallback } from "react";
import useOnboardingSteps from "../hooks/useOnboardingSteps";
import PrimaryButton from "./PrimaryButton";
import SecondaryButton from "./SecondaryButton";

const stepMap = {
  VIDEO: "KNOWLEDGE_SOURCES",
  KNOWLEDGE_SOURCES: "BRANDING",
  BRANDING: "INSTRUCT",
  INSTRUCT: "INTENTS",
  INTENTS: "ACTIONS",
  ACTIONS: "INVITE_TEAM",
  INVITE_TEAM: "DEPLOY",
  DEPLOY: "DEPLOY",
};

const HomeProgressStepSection = () => {
  const { onComplete, onSkip, currentStep, allCompleted, loading } =
    useOnboardingSteps();

  const submit = useCallback(
    isComplete => {
      const cb = isComplete ? onComplete : onSkip;
      const from = currentStep?.step || "VIDEO";
      const to = stepMap[from];
      cb(from, to);
    },
    [currentStep, onComplete, onSkip]
  );

  return (
    <div className="flex flex-col gap-2">
     <div className="player-wrapper rounded-2xl overflow-hidden relative w-full pt-[56.25%]">
        <iframe
          src="https://share.descript.com/embed/paVILn9VFgt"
          title="SupportMagic: AI-Powered Customer Support"
          frameBorder="0"
          allowFullScreen
          className="absolute top-0 left-0 w-full h-full"
        />
    </div>

      {!allCompleted && (
        <>
          <PrimaryButton
            loading={loading}
            onClick={() => submit(true)}
            type="button"
          >
            I completed this step
          </PrimaryButton>

          <SecondaryButton onClick={() => submit(false)} type="button">
            Skip step
          </SecondaryButton>
        </>
      )}
    </div>
  );
};

export default HomeProgressStepSection;
